// src/Services/fetchInyeccion.js
import { ApiRequestInterceptorQS } from "./apiRequestQS";
import { INYECCION } from "../Constants/Endpoinst";

const INYECCION_ENDPOINT = INYECCION.inyeccion;

/**
 * Trae los datos de operador de inyección.
 * Si se le pasa `fecha` como YYYY‑MM‑DD, lo incluye en la query:
 *  GET inyeccion/api_operador_inyeccion.php?fecha=2025-07-15
 */
export const getOperadorInyeccion = async (fecha) => {
    // Construye la URL con o sin parámetro fecha
    const url = fecha
        ? `${INYECCION_ENDPOINT}?fecha=${encodeURIComponent(fecha)}`
        : INYECCION_ENDPOINT;

    const { code, data } = await ApiRequestInterceptorQS(url, "GET");
    return { code, data };
};
